import type { FC } from 'react';

import {
    Body2,
    Box,
    FilledCard,
    Flex,
    IconChevronRight,
    Stack,
    TextButton,
} from '@myphx-engineering/phx-design-system';

import type { NdcSwitchConfig } from '../../../types/drug-config';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

import { SwitchTargetHeader } from './SwitchTargetHeader';

export type SwitchTargetSelectorProps = {
    prescriberOrderId: string;
    switchConfig: NdcSwitchConfig;
};

const makeLink = (prescriberOrderId: string, targetNdc: string): string =>
    getAbsoluteRoute('order.prescriberOrderId.switch.target.root', {
        prescriberOrderId,
        targetNdc,
    });

export const SwitchTargetSelector: FC<SwitchTargetSelectorProps> = ({
    prescriberOrderId,
    switchConfig,
}) => {
    const targets = switchConfig.targets.filter(
        (target) => Number(target.ndc) !== -1
    );

    return (
        <Stack gap="sm">
            {targets.map((target) => (
                <FilledCard key={target.ndc} color="primary" withBorder>
                    <Flex gap="xxs" wrap="wrap">
                        <Stack gap="xxxs">
                            <SwitchTargetHeader option={target} />

                            {target.shortDescription ? (
                                <Body2>{target.shortDescription}</Body2>
                            ) : null}
                            <Box mb="xxxs" mt="xxxs">
                                <TextButton
                                    link
                                    to={makeLink(prescriberOrderId, target.ndc)}
                                    RightIcon={IconChevronRight}
                                >
                                    See details
                                </TextButton>
                            </Box>
                        </Stack>
                    </Flex>
                </FilledCard>
            ))}
        </Stack>
    );
};
